/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/16/20 4:38 PM
 */

import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { formatDistance, isAfter, parseISO } from "date-fns";
import {persistState} from "../helpers";

export interface User  {
	id?: string
	fullName?: string
	firstName?: string
	lastName?: string
	location?: string
	jobTitle?: string
	businessUnit?: string
	sessionExpires?: string
}

export type UserState = User | null;
const STORAGE_KEY = "vega.user";

export const loadStoredUserData = (): UserState => {
	const savedUserData = localStorage.getItem(STORAGE_KEY);
	if (savedUserData) {
		const jsonData: UserState = JSON.parse(savedUserData);
		if (jsonData?.sessionExpires) {
			const sessionExpires = parseISO(jsonData.sessionExpires);
			if (isAfter(sessionExpires, new Date())) {
				console.log("Session expires in " + formatDistance(sessionExpires, new Date()));
				return jsonData;
			} else {
				return null;
			}
		}
	}
	return null;
}

let initialState: UserState = loadStoredUserData();

export const slice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		login: (state, action: PayloadAction<UserState>) => {
			persistState(STORAGE_KEY, action.payload);
			return action.payload;
		},
		logout: () => {
			localStorage.removeItem(STORAGE_KEY);
			return null;
		}
	},
});

export const { login, logout } = slice.actions;
export default slice.reducer;